module.exports = __webpack_public_path__ + "static/travel2022-724c925c5d39c9a2671bec3441e62385.jpg";